export const SliderData = [
  {
    image:
      'https://img.freepik.com/premium-photo/back-school-cute-education-scene-pixar-style_950002-230690.jpg?w=826',
    heading1:
      'கற்க கசடறக் கற்பவை கற்றபின்  ',
    heading2:
      'நிற்க அதற்குத் தக.',
    content:
      '"Accessing a world of knowledge at your fingertips, students diligently tackle assignments and collaborate effortlessly in this innovative virtual learning space. Maximize productivity and conquer challenges with ease."'
  },
  {
    image:
      'https://img.freepik.com/premium-photo/little-boy-doing-homework-by-read-writing-his-desk_999327-23314.jpg?w=740',
    heading1:
      'எண்ணென்ப ஏனை எழுத்தென்ப இவ்விரண்டும் ',
    heading2:
      'கண்ணென்ப வாழும் உயிர்க்கு..',
    content:
      '"Join students worldwide in a virtual space designed for productivity. Access resources, collaborate with peers, and conquer assignments effortlessly. Its time to thrive academically, anytime, anywhere"'
  },
  {
    image:
      'https://img.freepik.com/premium-photo/teaching-with-passion-pretty-teacher-smiles-with-pupils-teacher-s-day-back-school_210545-5212.jpg?w=740',
    heading1:
      'கண்ணுடையர் என்பவர் கற்றோர் முகத்திரண்டு ',
    heading2:
      'புண்ணுடையர் கல்லா தவர்.',
    content:
      '"where students thrive! Dive into focused work sessions, access expert guidance, and conquer your assignments with ease. Join our vibrant community of learners today!"'
  },
  {
    image:
      'https://sketchvalley.com/wp-content/uploads/2021/12/homework-assignment-details-1536x720.jpg',
    heading1:
      'உடையார்முன் இல்லார்போல் ஏக்கற்றுங் கற்றார் ',
    heading2:
      'கடையரே கல்லா தவர்',
    content:
      '"Engage, Learn,  your digital gateway to educational success. Organize, submit, and track assignments effortlessly. Download now and take control of your academic journey!"'
  },
  {
    image:
      'https://img.freepik.com/free-vector/young-boy-studying-front-computer_1308-77844.jpg?t=st=1711968777~exp=1711972377~hmac=3860413a84da15efa938b6c275a7fa21d0bcb26a74c6ef99ece15e17963d9314&w=826',
    heading1:
      'தொட்டனைத் தூறும் மணற்கேணி மாந்தர்க்குக்  ',
    heading2:
      'கற்றனைத் தூறும் அறிவு. ',
    content:
      '"Engage, Learn, Grow! Experience dynamic student-teacher interaction on our Homework Hub app. Connect seamlessly, ask questions, and explore together for academic success!"'
  }
];
